import { render, staticRenderFns } from "./ErroResultados.vue?vue&type=template&id=32cc313c&scoped=true&"
import script from "./ErroResultados.vue?vue&type=script&lang=js&"
export * from "./ErroResultados.vue?vue&type=script&lang=js&"
import style0 from "./ErroResultados.vue?vue&type=style&index=0&id=32cc313c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cc313c",
  null
  
)

export default component.exports